import { LayerInfo } from "./LayerInfo";

import Container = createjs.Container;

/**
 * A list of layers a disp contains. For example, a building can contain layers for smoke and flags.
 * The layers provide positioning infos that can be used to add children to a disp.
 */
export class ClipLayerInfo {
    private _layer: LayerInfo[];

    constructor(clip: Container = null) {
        if (clip) {
            this.parseLayer(clip);
        }
    }

    /**
     * Returns a list of layers
     */
    public get layer(): LayerInfo[] {
        return this._layer;
    }

    public set layer(value: LayerInfo[]) {
        this._layer = value;
    }

    /**
     * Searches for children in given object container and adds them to the layer list, if they also contain children.
     *
     * @param clip disp to search in
     */
    private parseLayer(clip: Container): void {
        this._layer = [];
        let subMC: Container;
        let subSubMC: Container;
        let layerInfo: LayerInfo;
        let index: number = 0;

        for (let i: number = 0; i < clip.numChildren; i++) {
            subMC = (<Container>clip.getChildAt(i));

            if (subMC) {
                let clipName: string = subMC.name;

                if (subMC.numChildren > 0) {
                    for (let j: number = 0; j < subMC.numChildren; j++) {
                        subSubMC = (<Container>subMC.getChildAt(j));

                        if (subSubMC) {
                            layerInfo = new LayerInfo(subSubMC.x, subSubMC.y, subSubMC.scaleX, index, clipName, subSubMC.rotation);
                            this._layer.push(layerInfo);
                            index++;
                        }
                    }
                }
                else {
                    layerInfo = new LayerInfo(subMC.x, subMC.y, subMC.scaleX, index, clipName, subMC.rotation);
                    this._layer.push(layerInfo);
                    index++;
                }
            }
        }
    }

    /**
     * @param layerName
     *
     * @return a vector of layers matching the layerName (empty vector, if there are no layers)
     */
    public getLayerByName(layerName: string): LayerInfo[] {
        let result: LayerInfo[] = [];

        for (let layerInfo of this._layer) {
            if (layerInfo.layerName == layerName) {
                result.push(layerInfo);
            }
        }
        return result;
    }
}
